// import http, { authHeader } from './index'
import http from './api'

const url = '/enums/'

export const httpGetEnums = () => {
  return http({
    url: `${url}`,
    method: 'GET',
  })
}
